module.exports = function() {
  return new Worker(__webpack_public_path__ + "000.004.004/worker.88ab0f0d0a1b537d9f1b.js");
};


// WEBPACK FOOTER //
// ./packages/lib-util/src/transaction/worker.js